var map = {
	"./gotfertomi-coussins-1.jpg": "1769",
	"./gotfertomi-coussins-2.jpg": "a1bd",
	"./gotfertomi-coussins-3.jpg": "92f6",
	"./gotfertomi-coussins-4.jpg": "d460",
	"./gotfertomi-coussins-5.jpg": "6b70",
	"./gotfertomi-coussins-6.jpg": "7358",
	"./gotfertomi-coussins-bretzel.jpg": "4b8e",
	"./gotfertomi-coussins-cafe-1.jpg": "080e",
	"./gotfertomi-coussins-cafe-2.jpg": "5b80",
	"./gotfertomi-coussins-cafe-3.jpg": "e0f7",
	"./gotfertomi-coussins-cafe-4.jpg": "d6b1",
	"./gotfertomi-coussins-cafe-5.jpg": "5bcf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5e19";